module.exports = __webpack_public_path__ + "img/HeroTypesQuiz_Hero-intro.195b67ac.png";